import {createStore, applyMiddleware} from 'redux'
import thunk from 'redux-thunk'
import keyMirror from 'keymirror'
import {v4 as uuidv4} from 'uuid';
import {Base64} from "../helpers/Base64";
import {isObject, validateEmail} from "../helpers/utils";

const _clientId = Base64.encode('clientId');

export const Actions = keyMirror({
  UPDATE_SOURCE: null,
  VERIFY_CLIENT: null,
  LOAD_COMPARISON_RESULT: null,
  DEMO_USED: null,
  UPDATE_PROCESSING: null,
  UPDATE_PROGRESS: null,
  Show_Backgroundvideo: null,
  ACCEPT_TERMS: null,
  MARK_SELECTED_ONLY: null,
  SET_SEND_BY_EMAIL: null,
  SET_EMAIL: null,
  SET_DONATION: null,
  SET_DONATION_AMOUNT: null
});

export const ComparisonSourceTypes = keyMirror({
  ORIGINAL: null,
  USER: null
});

export const InputTypes = keyMirror({
  TEXT: null,
  FILE: null
});
// stale dla programu
 
export const backendServerURLone='https://api-new-jsa.poprawaprac.pl';//'http://localhost:5000'//;
export const errorconection='Niestety serwer aktualnie nie pracuje. Prowadzone są prace konserwacyjne, spróbuj za chwile odświerzyć strone. Jeżeli wciąż widzisz ten komunikat napisz do administratora na email katarzynabatkontakt@gmail.com ';
const initialState = {
  backurl:'https://api-new-jsa.poprawaprac.pl/confirmPayment',//'https://poprawaprac.pl/program-antyplagiatowy-wrona/' ,'https://api-new-jsa.poprawaprac.pl/about'//
  unitAmount: 100,
  unitPrice: 0.3,
  taxAmount: 0.23,
  demoAllowed: false, // less or equal 700 chars
  demoAvailable: false, // never done before
  charCount: null,
  paid: false,
  report: null,
  tryDemo: false,//localStorage.getItem('tryDemo') === 'true',
  freeDemoCharLimit: 700,
  processing: false,
  pathreturnpage: 'https://poprawaprac.pl/raport-jsa/',
  inProgress: false,
  compareview:false,
  isAdmin: false,
  specialOffer: false,//(new Date()) < (new Date('2031-05-16')),
  selectedOnly: ['true', null].includes(localStorage.getItem('selectedOnly')),
  acceptedTerms: localStorage.getItem('acceptTerms') === 'true',
  sendByEmailJSA: localStorage.getItem('sendByEmailJSA') === 'true',
  donationAmount: 20,
  ...(() => {
    //spradzic
    const originalSource = {
      inputType: null,
      filename: null,
      content: null,
      isJSAReport: false,
      wordCount: 0,
      initialWordCount: 0
    };//ustawienie id klienta
    let clientId = localStorage.getItem(_clientId);
    if (!clientId) {
      clientId = uuidv4();
      localStorage.setItem(_clientId, clientId);
    }
    const email = localStorage.getItem('email') || null;
    return {
      email ,
      wrongEmail: !validateEmail(email),
      clientId,
      transactionId: (new URLSearchParams(window.location.search)).get('tid'),
      adminId: (new URLSearchParams(window.location.search)).get('adminId'),
      donate: false,//(new URLSearchParams(window.location.search)).get('donate'),
      originalSource,
      userSource: {...originalSource}
    };
  })()
}

const store = (state, action) => {
  let newState, charCount;
  switch (action.type) {
    case Actions.SET_EMAIL:
      return {
        ...state,
        ...(() => {
          const email = action.payload || null;
          return {
            email,
            wrongEmail: !validateEmail(email)
          }
        })(),
      }
    //wysylanie emaila
    case Actions.SET_SEND_BY_EMAIL:
      return {
        ...state,
        sendByEmailJSA: action.payload
      }
    // progres
    case Actions.UPDATE_PROGRESS:
      return {
        ...state,
        inProgress: action.payload,
      
      }
    //akceptacja warunkow
    case Actions.ACCEPT_TERMS:
      return {
        ...state,
        acceptedTerms: action.payload
      }
  //zaznaczony tylko
    case Actions.MARK_SELECTED_ONLY:
      return {
        ...state,
        selectedOnly: action.payload.selectedOnly,
        processing: false,
        originalSource: {
          ...state.originalSource,
          wordCount: action.payload.originalWordCount
        }
      }
  //sprawdz co tu się dzieje
    case Actions.UPDATE_PROCESSING:
      return {
        ...state,
        ...action.payload.processing !== undefined && {
          processing: action.payload.processing
        },
        ...action.payload.tryDemo !== undefined && {
          tryDemo: action.payload.tryDemo
        }
      }
    //uzycie dema
    case Actions.DEMO_USED:
      return {
        ...state,
        tryDemo: true
      }
    //locastor klijent do opisania
    case Actions.VERIFY_CLIENT:
      if (action.payload.clientId) {
        localStorage.setItem(_clientId, action.payload.clientId)
      }
      return {
        ...state,
        unitAmount: action.payload.unitAmount,
        unitPrice: action.payload.unitPrice,
        taxAmount: action.payload.taxAmount,
        ...action.payload.inProgress !== undefined && {
          inProgress: action.payload.inProgress
        },//dodane 
        
        ...action.payload.processing !== undefined && {
          processing: action.payload.processing
        },
        ...action.payload.isAdmin !== undefined && {
          isAdmin: action.payload.isAdmin
        },
        demoAvailable: action.payload.demoAvailable,
        demoAllowed: action.payload.demoAllowed,
        charCount: action.payload.charCount || 0,
        freeDemoCharLimit: action.payload.freeDemoCharLimit,
        paid: action.payload.paid,
        ...action.payload.originalFilename && {
          originalSource: {
            ...state.originalSource,
            inputType: InputTypes.FILE,
            filename: action.payload.originalFilename,
            ...action.payload.isJSAReport !== undefined && {
              isJSAReport: action.payload.isJSAReport
            },
            wordCount: action.payload.originalWordCount || 0,
            initialWordCount: action.payload.originalWordCount || 0
          }
        },
        ...action.payload.userFilename && {
          userSource: {
            ...state.userSource,
            inputType: InputTypes.FILE,
            filename: action.payload.userFilename,
            charCount: action.payload.charCount || 0,
            wordCount: action.payload.userWordCount || 0,
            initialWordCount: action.payload.userWordCount || 0
          }
        },
        ...action.payload.originalContent && {
          originalSource: {
            ...state.originalSource,
            inputType: InputTypes.TEXT,
            content: action.payload.originalContent,
            wordCount: action.payload.originalWordCount || 0,
          }
        },
        ...action.payload.userContent && {
          userSource: {
            ...state.userSource,
            inputType: InputTypes.TEXT,
            content: action.payload.userContent,
            wordCount: action.payload.userWordCount
          }
        },
        ...action.payload.report && isObject(action.payload.report) && {
          report: action.payload.report
        }
      };
    
    case Actions.UPDATE_SOURCE:
      newState = {
        ...state,
        [`${action.payload.sourceType.toLowerCase()}Source`]: {
          ...state[`${action.payload.sourceType.toLowerCase()}Source`],
          inputType: action.payload.inputType,
          ...action.payload.filename && {filename: action.payload.filename},
          ...action.payload.content !== undefined && {content: action.payload.content},
          ...action.payload.inputType === InputTypes.FILE && action.payload.charCount !== undefined && {
            charCount: action.payload.charCount,
          },
          ...action.payload.inputType === InputTypes.FILE && {
            wordCount: action.payload[`${action.payload.sourceType.toLowerCase()}WordCount`] || state[`${action.payload.sourceType.toLowerCase()}Source`].initialWordCount,
            ...action.payload[`${action.payload.sourceType.toLowerCase()}WordCount`] && {
              initialWordCount: action.payload[`${action.payload.sourceType.toLowerCase()}WordCount`]
            }
          },
          ...action.payload.sourceType === ComparisonSourceTypes.ORIGINAL && action.payload.inputType === InputTypes.FILE && action.payload.isJSAReport !== undefined && {
            isJSAReport: action.payload.isJSAReport,
          },
          ...action.payload.inputType === InputTypes.TEXT && (() => {
            const content = action.payload.content ||
              (action.payload.content === undefined && state[`${action.payload.sourceType.toLowerCase()}Source`].content)
              || '';
            return {
              wordCount: content.replace(/[\s+|/.+]/g, ' ').split(/[^\w$żźćńółęąśŻŹĆĄŚĘŁÓŃ]|[0-9\\?]/).filter(w => w.length > 1).length
            }
          })()
        }
      };
      charCount = action.payload.charCount !== undefined ?
        action.payload.charCount :
        (newState.userSource.inputType === InputTypes.TEXT ?
            // eslint-disable-next-line no-mixed-operators
            (newState.userSource.content && newState.userSource.content.length || 0) :
            (newState.userSource.charCount || 0)
        );
      return {
        ...newState,
        demoAllowed: action.payload.demoAllowed !== undefined ? action.payload.demoAllowed : charCount <= newState.freeDemoCharLimit,
        charCount,
        ...action.payload.processing !== undefined && {
          processing: action.payload.processing
        },
      };
      //ladowanie wynikow porownania
      case Actions.Show_Backgroundvideo:
        return{
          ...state,
        compareview: action.payload
        }
          
        
    case Actions.LOAD_COMPARISON_RESULT:
      return {
        ...state,
        ...action.payload.processing !== undefined && {
          processing: action.payload.processing
        },
        ...action.payload.inProgress !== undefined && {
          inProgress: action.payload.inProgress
        },
       
        
        ...action.payload.report && isObject(action.payload.report) && {
          report: action.payload.report
        },
        ...action.payload.tryDemo && {
          demoAllowed: false,
          demoAvailable: false
        },
        ...action.payload.tryDemo !== undefined && {
          tryDemo: action.payload.tryDemo
        },
        ...action.payload.transactionId !== undefined && {
          transactionId: action.payload.transactionId
        },
        originalSource: {...initialState.originalSource},
        userSource: {...initialState.userSource},
        paid: false
      };
      
    case Actions.SET_DONATION:
      return {
        ...state,
        donate: action.payload.donate
      }
      
    case Actions.SET_DONATION_AMOUNT:
      return {
        ...state,
       donationAmount: parseFloat(action.payload.donationAmount)
     
      }
      
    default:
      return {...state};
  }
};

export default createStore(store, {...initialState}, applyMiddleware(thunk));
